// extracted by mini-css-extract-plugin
export default {"btnVoucher":"AllVendors_btnVoucher__GLNIP","disabled":"AllVendors_disabled__-WiFK"};